import home from "./home";
import monitor from "./monitor";
import block from "./block";

export default {
  home,
  monitor,
  block
};



// WEBPACK FOOTER //
// ./src/api/index.js